export const MANAGER_ROLES = ['mgmt'];

export const isManager = (role?: string | null): boolean =>
  !!role && MANAGER_ROLES.includes(role);
